import { ChangeDetectionStrategy, Component, computed, inject, viewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarsComponent, Person, TooltipModule } from '@libs/ui-lib';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { HealthHistoryDialogService } from '@libs/home';
import { CdkAccordionItem, CdkAccordionModule } from '@angular/cdk/accordion';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { selectSiteSettingsPmsType } from '@libs/store';
import { PmsType } from '@ffd/api-client';
import { Store } from '@ngrx/store';
import { FullNamePipe, AgePipe } from '../../pipes';
import { HealthHistoryPatientSecondaryContactsComponent } from './components/health-history-patient-details-secondary-contacts/health-history-patient-secondary-contacts.component';
import { HealthHistoryPatientDetailsItemComponent } from './components/health-history-patient-details-item/health-history-patient-details-item.component';

@Component({
  selector: 'lib-health-history-patient-details',
  standalone: true,
  imports: [
    CommonModule,
    FullNamePipe,
    AvatarsComponent,
    TranslateModule,
    TooltipModule,
    SvgIconComponent,
    AgePipe,
    CdkAccordionModule,
    HealthHistoryPatientSecondaryContactsComponent,
    HealthHistoryPatientDetailsItemComponent,
  ],
  templateUrl: './health-history-patient-details.component.html',
  styleUrl: './health-history-patient-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('slideToggle', [
      state('void', style({ height: '0px', opacity: 0, overflow: 'hidden' })),
      state('collapsed', style({ height: '0px', opacity: 0, overflow: 'hidden' })),
      state('expanded', style({ height: '*', opacity: 1, overflow: 'hidden' })),
      transition('collapsed <=> expanded', animate('300ms ease-in-out')),
      transition('void => *', animate('300ms ease-in-out')),
    ]),
  ],
})
export class HealthHistoryPatientDetailsComponent {
  private readonly healthHistoryDialogService = inject(HealthHistoryDialogService);
  private readonly store = inject(Store);

  private readonly accordionItem = viewChild<CdkAccordionItem>('accordionItem');
  private readonly secondaryPatientContacts = viewChild<HealthHistoryPatientSecondaryContactsComponent>(
    HealthHistoryPatientSecondaryContactsComponent,
  );

  protected readonly patient = computed(() => this.healthHistoryDialogService.viewModel().patient);
  protected readonly patientAvatar = computed(() => this.patient() as Person);

  private readonly pmsType = this.store.selectSignal(selectSiteSettingsPmsType);
  public readonly isOpenDental = computed(() => this.pmsType() === PmsType.OPEN_DENTAL);

  public closeAccordion(): void {
    const accordionItem = this.accordionItem();
    const secondaryPatientContacts = this.secondaryPatientContacts();

    if (accordionItem && accordionItem.expanded) {
      accordionItem.close();
    }
    if (secondaryPatientContacts && secondaryPatientContacts.contactForm.dirty) {
      secondaryPatientContacts.saveContactDetails();
    }

    if (secondaryPatientContacts && !secondaryPatientContacts.contactForm.dirty && secondaryPatientContacts.isEditMode()) {
      secondaryPatientContacts.cancel();
    }
  }
}
